import script from "./BoardDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardDetailView.vue?vue&type=script&setup=true&lang=js"

import "./BoardDetailView.vue?vue&type=style&index=0&id=5889751e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5889751e"]])

export default __exports__